import { useState } from "react";
import { Col, Form } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { axiosInstance } from "../../auth/Auth";

export default function AsyncSongPicker({ formData, setFormData, name, formKey, disabled, label }) {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);

    async function searchSuggestions(pattern) {
        setFormData({ ...formData, [formKey]: pattern.trim() });
        if (pattern.trim().length >= 3) {
            setLoading(true);
            const response = await axiosInstance.get(`items/songs/${formKey}s/?${formKey}=${encodeURIComponent(pattern)}`);
            setOptions(response.data);
            setLoading(false);
        }
    }

    return (
        <Form.Group as={Col} className="col-12 col-xl-4">
            <Form.Label>{label}</Form.Label>
            <AsyncTypeahead
                id={`${name}-${formKey}`}
                isLoading={loading}
                onSearch={searchSuggestions}
                className="autocomplete"
                options={options}
                emptyLabel="No suggestions"
                onChange={val => val?.length && setFormData({ ...formData, [formKey]: val[0]?.trim() })}
                onInputChange={searchSuggestions}
                disabled={disabled || false}
            />
        </Form.Group>
    );
}
